import { useTranslation } from "react-i18next";
import { CoreSearchField, CoreSearchFieldPaper } from "@verity/components/core";
import styles from "./roster-search-bar.module.css";
import { memo, ReactNode, useState } from "react";
import { useAppDispatch } from "./store/roster-hooks";
import { setSearchQuery } from "./store/roster-slice";
import { MemoizedRosterFilterButton } from "./roster-filter-button";

export function RosterSearchBar({
	ariaControls,
	totalResults,
	children,
}: {
	ariaControls: string;
	totalResults: number;
	children?: ReactNode;
}) {
	const { t } = useTranslation();
	const dispatch = useAppDispatch();

	const [activeSearchQuery, setActiveSearchQuery] = useState("");

	function handleSearch(value: string) {
		setActiveSearchQuery(value);
		dispatch(setSearchQuery({ idOrEmail: value }));
	}

	return (
		<CoreSearchFieldPaper>
			<MemoizedRosterFilterButton />
			<CoreSearchField
				className={styles.searchField}
				onSearch={(value) => handleSearch(value)}
				label={t("portal.components.roster.search.placeHolder")}
				ariaControls={ariaControls}
				totalResults={totalResults}
				showSearchButton
				value={activeSearchQuery}
			/>
			{children}
		</CoreSearchFieldPaper>
	);
}

export const MemoizedRosterSearchBar = memo(RosterSearchBar);
